import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {getOrganizations, getOrganization, createOrganization, updateOrganization, deleteOrganization } from '../../../lib/requests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) {
    return e.response.data;
  }
  return 'An unexpected error occurred';
}

export function* getOrganizationsRequestWatcher() {
  for (;;) {
    yield take(types.GET_ORGANIZATIONS_REQUEST);
    try {
      var response = yield call(getOrganizations);
      yield put(actions.getOrganizationsSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrganizationsFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getOrganizationRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORGANIZATION_REQUEST);
    try {
      var response = yield call(getOrganization, request.payload);
      yield put(actions.getOrganizationSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrganizationFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrganizationRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORGANIZATION_REQUEST);
    try {
      var response = yield call(createOrganization, request.payload);
      yield put(actions.createOrganizationSuccess(response.data));
    } catch (e) {
      yield put(actions.createOrganizationFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrganizationRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORGANIZATION_REQUEST);
    try {
      var response = yield call(
        updateOrganization,
        request.payload.guid,
        request.payload
      );
      yield put(actions.updateOrganizationSuccess(response.data));
    } catch (e) {
      yield put(actions.updateOrganizationFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrganizationRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORGANIZATION_REQUEST);
    try {
      yield call(deleteOrganization, request.payload);
      yield put(actions.deleteOrganizationSuccess(request.payload));
    } catch (e) {
      yield put(actions.deleteOrganizationFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
